import React, { useEffect, useState } from 'react';
// Components
import Navbar from '../../components/nav/Navbar';
import FooterComponent from '../../components/footer/FooterComponent';
import GalleryPageMainContainer from '../../components/gallery/GalleryPageMainContainer';
import GeneralHeader from '../../components/header/GeneralHeader';
import PageDivider from '../../components/gallery/PageDivider';
import { HelmetItem } from '../../components/utils/HelmetItem';
// Constants
import { CompanyName, KeywordsPages, LocationCountry } from '../../utils/Constants';
// Data
import {
  galleryPageAdditionalMeta,
  galleryPageStructuredData,
} from '../../utils/data/MetaData';

const GalleryPage = React.memo(() => {
  const [hideNavbar, setHideNavbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById('scroll-section-gallery');
      if (!section) return;

      const sectionBottom = section.getBoundingClientRect().bottom;
      setHideNavbar(sectionBottom <= 130); // Hide navbar 50px before section disappears
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <HelmetItem
        PageName='Gallery'
        desc={`Explore the captivating world of ${CompanyName} through our gallery. View exclusive images showcasing our sessions and experiences in ${LocationCountry}.`}
        keywords={`gallery, photos, sessions, BDSM, ${CompanyName}, ${LocationCountry}, experiences, ${KeywordsPages}`}
        additionalMeta={galleryPageAdditionalMeta}
        structuredData={galleryPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen font-main bg-colour1 dark:bg-colour2 text-colour2 dark:text-colour1 overflow-hidden'>
        {/* Nav + header section */}
        <div
          id='scroll-section-gallery'
          className='grid bg-colour4 dark:bg-colour4 full_shadow_black_invert min-h-[45vh] max-h-[45vh]'
        >
          {/* Navigation */}
          <Navbar isHidden={hideNavbar} />

          {/* Divider */}
          <PageDivider />

          {/* Header */}
          <GeneralHeader
            page={`My Gallery`}
            title={`Erotic Content & Sex Fantasies`}
          />
        </div>

        <GalleryPageMainContainer />
        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
});

export default GalleryPage;
